<template>
  <div class="quantity-warpper">
    <span
      class="quantitytext"
      v-if="$route.path === '/order-success'"
						data-test="priceQuantityChangerHead"
						id="priceQuantityChangerHead"
    >
      Quantity
    </span>
    <!--<integer-plusminus-->
      <!--:min="1"-->
      <!--:max="(product.max_quantity > product.stock)?-->
                         <!--product.stock:product.max_quantity"-->
      <!--v-model="product.quantity"-->
    <!--&gt;-->
    <!--</integer-plusminus>-->

			<!--custom vue integer plus minus plugin-->
			<vue-integer-plus-minus
				:min="1"
				:max="(product.max_quantity > product.stock)?
                         product.stock:product.max_quantity"
				v-model="product.quantity"
			>
			</vue-integer-plus-minus>
			<!--custom vue integer plus minus plugin-->

    <!-- mobile -->
    <div
      class="select"
      name="quantityMoreSelectorMobile"
      :id="'quantity-selector-mobile-more-'+index"
      @click.prevent="toggleQty"
      :class="{ 'disable-element': disabled }"
						data-test="priceQuantityChangerSelect"
    >
      <span class="" data-test="priceQuantityChangerSpan"
												id="priceQuantityChangerSpan">
        Qty: {{product.quantity}}
      </span>
      <div
        class="options"
        :id="'qty00'+index"
      >
        <div
          class="option"
          v-for="(item) in (product.max_quantity)< 3 ? product.max_quantity : 3"
          :value="item"
          :key="item"
          :id="'item'+index"
          @click.prevent="product.quantity = item"
										data-test="priceQuantityChangerSelectItem"
        >
          {{item}}
        </div>
        <div
          class="option"
          data-toggle="modal"
          :data-target="'#priceModal-'+index"
										data-test="priceQuantityChangerSelectMore"
										id="priceQuantityChangerSelectMore"
        >
          More
        </div>
      </div>
    </div>
    <!-- mobile -->
  </div>
</template>

<script>
// import { IntegerPlusminus } from 'vue-integer-plusminus'
import { mapActions, mapGetters } from 'vuex'
import VueIntegerPlusMinus from '../../../../../../widgets/VueIntegerPlusMinus'

export default {
	components: {
		VueIntegerPlusMinus
	},
	computed: {
		...mapGetters('buynow', ['getBuyNowProductCount']),
		quantity () {
			let qnty = 1
			if (this.product.quantity <= this.product.max_quantity &&
        this.product.quantity <= this.product.stock) {
				qnty = this.product.quantity
			} else {
				qnty = (this.product.max_quantity > this.product.stock
					? this.product.stock : this.product.max_quantity)
			}
			return qnty
		}
	},
	mounted () {
		if (this.product.quantity === 0) {
			this.product.quantity = 1
		}
	},
	props: {
		product: {},
		index: {
			default: 0,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		...mapActions('cart', ['updateCartQuantity']),
		...mapActions('buynow', ['updateBuyNowQuantity']),
		toggleQty () {
			if (document.getElementById(`qty00${this.index}`)
				.classList
				.contains('open')) {
				document.getElementById(`qty00${this.index}`)
					.classList
					.remove('open')
			} else {
				document.getElementById(`qty00${this.index}`)
					.classList
					.add('open')
			}
		},
		quantityUpdator () {
			if (this.product.quantity > this.product.max_quantity ||
        this.product.quantity > this.product.stock) {
				if (this.product.quantity !== 0) {
					this.$toasted.show(`You can buy only ${(this.product.max_quantity > this.product.stock) ? this.product.stock : this.product.max_quantity} units of this product`)
				}
			} else if (this.product.quantity > 0 &&
        this.product.quantity <= this.product.max_quantity) {
				if (this.getBuyNowProductCount > 0) {
					this.updateBuyNowQuantity(this.product.quantity)
				} else {
					this.updateCartQuantity()
				}
			}
			this.$forceUpdate()
		}
	},
	watch: {
		quantity: {
			handler (val) {
				this.product.quantity = val
			},
			deep: true
		},
		'product.quantity': function () {
			if (this.product.quantity > this.product.max_quantity ||
        this.product.quantity > this.product.stock) {
				this.product.quantity = (this.product.max_quantity > this.product.stock
					? this.product.stock : this.product.max_quantity)
			} else if (this.product.quantity === 0) {
				this.product.quantity = 1
			}
			this.quantityUpdator()
		}
	}
}
</script>

<style scoped>
.disable-element {
  pointer-events: none;
  cursor: default;
}
</style>
